import { Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { Kit } from "@/dev/Kit";
import { Admin } from "@/pages/Admin";
import { Ayarlar } from "@/pages/Ayarlar";
import { Denetim } from "@/pages/Denetim";
import { EmbedIkas } from "@/pages/EmbedIkas";
import { Giris } from "@/pages/Giris";
import { Kayit } from "@/pages/Kayit";
import { Kpi } from "@/pages/Kpi";
import { Kullanicilar } from "@/pages/Kullanicilar";
import { Kurulum } from "@/pages/Kurulum";
import { Ozet } from "@/pages/Ozet";
import { Sifre } from "@/pages/Sifre";
import { Stok } from "@/pages/Stok";
import { TenantSec } from "@/pages/TenantSec";
import { Yorumlar } from "@/pages/Yorumlar";
import { RequireAuth, RequireSuper, RequireTenant, RequireTenantAdmin } from "@/routes/guards";

/** Bilgi mimarisi — docs/faz5-arayuz-spec.md §2. */
export function App() {
  return (
    <Routes>
      {/* -- herkese acik --------------------------------------------------- */}
      <Route path="/giris" element={<Giris />} />
      <Route path="/kayit" element={<Kayit />} />
      <Route path="/kayit/:tenantSlug" element={<Kayit />} />

      {/* -- gomulu (ikas) — kendi disi Layout, embedded oturum -------------- */}
      <Route
        path="/embed/ikas"
        element={
          <RequireTenant>
            <EmbedIkas />
          </RequireTenant>
        }
      />

      {/* -- oturum sarti (tenant sarti yok) ---------------------------------- */}
      <Route
        path="/tenant-sec"
        element={
          <RequireAuth>
            <TenantSec />
          </RequireAuth>
        }
      />
      <Route
        path="/sifre"
        element={
          <RequireAuth>
            <Sifre />
          </RequireAuth>
        }
      />

      {/* -- vdd_super (tenant sarti yok — RequireSuper'in kendi belgesi: bkz.
           routes/guards.tsx; hic uyeligi olmayan/aktif tenant secmemis bir
           supernin /admin'e (tenant olustur/tenant'a gec) ulasabilmesi icin
           tenant_user govdesinin (RequireTenant) DISINDA, ayri bir ust
           seviye rota olarak tanimlanir) ------------------------------------ */}
      <Route
        path="/admin"
        element={
          <RequireSuper>
            <Admin />
          </RequireSuper>
        }
      />

      {/* -- tenant_user govdesi (Layout: ust bar + gezinme) ------------------ */}
      <Route
        element={
          <RequireTenant>
            <Layout />
          </RequireTenant>
        }
      >
        <Route path="/ozet" element={<Ozet />} />
        <Route path="/kpi" element={<Kpi />} />
        <Route path="/stok" element={<Stok />} />
        <Route path="/yorumlar" element={<Yorumlar />} />
        <Route path="/denetim" element={<Denetim />} />

        {/* -- tenant_admin ---------------------------------------------------- */}
        <Route
          path="/ayarlar"
          element={
            <RequireTenantAdmin>
              <Ayarlar />
            </RequireTenantAdmin>
          }
        />
        <Route
          path="/kurulum"
          element={
            <RequireTenantAdmin>
              <Kurulum />
            </RequireTenantAdmin>
          }
        />
        {/* ikas OAuth donusu (app/core/api/ikas.py callback_endpoint) buraya
            yonlendirir — Kurulum sayfasini dogrudan "Kimlik bilgileri"
            adimiyla acar (bkz. Kurulum.tsx dosya notu). */}
        <Route
          path="/kurulum/ikas/tamam"
          element={
            <RequireTenantAdmin>
              <Kurulum initialStep="credentials" />
            </RequireTenantAdmin>
          }
        />
        {/* IdeaSoft OAuth donusu (backend /api/v2/ideasoft/callback) — ikas
            rotasiyla ayni desen: dogrudan "Kimlik bilgileri" adimini acar. */}
        <Route
          path="/kurulum/ideasoft/tamam"
          element={
            <RequireTenantAdmin>
              <Kurulum initialStep="credentials" />
            </RequireTenantAdmin>
          }
        />
        <Route
          path="/kullanicilar"
          element={
            <RequireTenantAdmin>
              <Kullanicilar />
            </RequireTenantAdmin>
          }
        />
      </Route>

      {/* -- gorsel denetim (dev) --------------------------------------------- */}
      <Route path="/dev/kit" element={<Kit />} />

      <Route path="/" element={<Navigate to="/ozet" replace />} />
      <Route path="*" element={<Navigate to="/ozet" replace />} />
    </Routes>
  );
}
